// @format

import { fetchPhoneNumber } from "../../prospect";

export function initProfileCardPhoneRefetch(): void {
  $(document)
    .off("click", ".profile-phone-refetch-btn")
    .on("click", ".profile-phone-refetch-btn", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const $button = $(this);
      const $row = $button.closest(".phone-contact-row");
      const $icon = $button.find("i");
      const $sub = $row.find(".cr-sub");

      $button.prop("disabled", true);
      $icon.addClass("fa-spin");
      $sub.text("Fetching…");

      fetchPhoneNumber($button.data("prospect-id"), { bots_prospect_id: $button.data("bots-prospect-id") })
        .done((data) => {
          if (data.status === "found" && data.phone_row_html) {
            $row.replaceWith(data.phone_row_html);
          } else {
            $sub.text("Not found");
          }
        })
        .fail(() => {
          $sub.text("Not found");
          alert("Failed to fetch phone number");
        })
        .always(() => {
          $button.prop("disabled", false);
          $icon.removeClass("fa-spin");
        });
    });
}
